import React from 'react';
import { FormField } from '../../components/FormField';
import { FormRow } from '../../components/FormRow';
import { LocationSelector } from '../../../../ui/LocationSelector';
import { PhoneInput } from '../../../../ui/PhoneInput';

interface OwnerInfoProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

export const OwnerInfo: React.FC<OwnerInfoProps> = ({ formData, handleInputChange }) => {
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange(e);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
        Informations du propriétaire
      </h3>
      
      <FormField label="Civilité">
        <select
          name="ownerCivility"
          value={formData.ownerCivility}
          onChange={handleInputChange}
          className="w-full"
        >
          <option value="">Sélectionner</option>
          <option value="M.">M.</option>
          <option value="Mme">Mme</option>
          <option value="Mlle">Mlle</option>
        </select>
      </FormField>

      <FormRow>
        <FormField label="Nom">
          <input
            type="text"
            name="ownerLastName"
            value={formData.ownerLastName}
            onChange={(e) => {
              // Convertir automatiquement en majuscules
              const upperValue = e.target.value.toUpperCase();
              handleInputChange({
                target: {
                  name: 'ownerLastName',
                  value: upperValue,
                  type: 'text'
                }
              } as React.ChangeEvent<HTMLInputElement>);
            }}
            placeholder="Nom"
            style={{ textTransform: 'uppercase' }}
            title="Le nom sera automatiquement converti en majuscules"
          />
        </FormField>

        <FormField label="Prénom">
          <input
            type="text"
            name="ownerFirstName"
            value={formData.ownerFirstName}
            onChange={handleInputChange}
            placeholder="Prénom"
          />
        </FormField>
      </FormRow>

      <FormField label="Adresse">
        <input
          type="text"
          name="ownerAddress"
          value={formData.ownerAddress}
          onChange={handleInputChange}
          placeholder="Adresse complète du propriétaire"
        />
      </FormField>

      <LocationSelector
        wilayaName="ownerWilaya"
        wilayaValue={formData.ownerWilaya}
        communeName="ownerCity"
        communeValue={formData.ownerCity}
        onWilayaChange={handleInputChange}
        onCommuneChange={handleInputChange}
      />

      <FormRow>
        <FormField label="Téléphone">
          <input
            type="tel"
            name="ownerPhone"
            value={formData.ownerPhone}
            onChange={handleInputChange}
            placeholder="+213 555 123 456 avec indicatif pays"
            title="Saisissez le numéro complet avec l'indicatif pays (ex: +213 555 123 456 pour l'Algérie, +33 6 12 34 56 78 pour la France)"
          />
        </FormField>

        <FormField label="Email">
          <input
            type="email"
            name="ownerEmail"
            value={formData.ownerEmail}
            onChange={handleInputChange}
          />
        </FormField>
      </FormRow>
    </div>
  );
};